const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';
const TOKEN_KEY = 'investt_auth_token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.status = status;
    this.payload = payload;
  }
}

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    // No JSON body (e.g. 204) — fine.
  }

  if (!response.ok) {
    throw new ApiError(payload?.error || `Request failed (${response.status})`, response.status, payload);
  }

  return payload;
}

export const api = {
  register: (data) => request('/auth/register', { method: 'POST', body: data, auth: false }),
  requestOtp: (data) => request('/auth/request-otp', { method: 'POST', body: data, auth: false }),
  verifyOtp: (data) => request('/auth/verify-otp', { method: 'POST', body: data, auth: false }),
  getProfile: () => request('/profile'),
  updateProfile: (data) => request('/profile', { method: 'PUT', body: data }),
  getGoals: () => request('/goals'),
  saveGoals: (goals) => request('/goals', { method: 'PUT', body: { goals } })
};

export { ApiError };